import { useSelector } from 'react-redux';
import { State } from 'redux/initialState';

import { usePartnerData } from './usePartnerData';
import { usePartnerInversion } from './usePartnerInversion';
import { useSocietyInitialization } from './useSocietyInitialization';

type PartnerDetailProps = {
  partnerId: string;
  societyId: string;
};

export const usePartnerDetail = ({
  partnerId,
  societyId,
}: PartnerDetailProps) => {
  const actualSociety = useSelector(
    (state: State) => state.society?.actualSociety
  );

  const { isLoading: isSocietyLoading, isError: isSocietyError } =
    useSocietyInitialization(societyId, actualSociety);

  const {
    partner,
    incorporationDate,
    fetchPartnerData,
    isLoading: isPartnerLoading,
    isError: isPartnerError,
  } = usePartnerData(partnerId, actualSociety);

  const {
    inversion,
    isLoading: isInversionLoading,
    isError: isInversionError,
  } = usePartnerInversion(partnerId, societyId);

  const isLoading = isSocietyLoading || isPartnerLoading || isInversionLoading;

  const isError = isSocietyError || isPartnerError || isInversionError;

  return {
    data: {
      partner,
      incorporationDate,
      inversion,
    },
    actions: {
      fetchPartnerData,
    },
    isLoading,
    isError,
  };
};
